import React from "react";

export default function DroppablePlaceholder() {
  return <div className="h-[60px] w-[1px]"></div>;
}
